import { types } from "../types/types";

const initialState = {
  cargada: false,
  cantidades: [],
  items: [],
  loading: false,
  error: null,
};

export const bandejaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.bandejaTraerCantidades:
      return {
        ...state,
        cantidades: action.payload,
        loading: false,
        error: null,
        cargada: true,
      };  
    case types.bandejaTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.bandejaTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.bandejaTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
    case types.bandejaLimpiar:
      return {
        ...state,
        loading: false,
        items: [],
        cargada: false,
        seleccionado: false
      };
    default:
      return state;
  }
};
